import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { DownloadIcon } from "../../Assets/assets";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";
import Button from "../../Components/Button/Button";
import {
  GraphCard,
  //  InfoCard,
  LegendCard
} from "../../Components/Cards/Cards";
import FilterCarousal from "../../Components/FilterCarousal/FilterCarousal";
import DateRange from "../../Components/Filters/DateRange";
import MultipleSelect from "../../Components/Filters/MultipleSelect";
// import SingleSelect from "../../Components/Filters/SingleSelect";
import BarChart from "../../Components/Graphs/BarChart";
import { DoughnutChart } from "../../Components/Graphs/DoughnutChart";
import LineChart from "../../Components/Graphs/LineChart";
import ComplaintsPreview from "../../Components/Previews/ComplaintsPreview";
import SearchBox from "../../Components/SearchBox/SearchBox";
import Table from "../../Components/Table/Table";
import { useHorizontalScroll } from "../../CustomHooks/useHorizontalScroll";
import { useResizeObserver } from "../../CustomHooks/useResizeObserver";
import {
  complaintTakeover,
  fixComplaints,
  getAllComplaintsCount,
  setSelectedComplaint,
  verifyCompliant
} from "../../Redux/complaints/action";
import { setErrorStatus } from "../../Redux/status/action";
import {
  setSelectedTableData,
  setTableFilter,
  setTableSearchKey,
  setTableSort
} from "../../Redux/table/action";
import { isValidObject } from "../../Services/validators";
import {
  complaintFilterData,
  complaintsQueryBuilder,
  complaintsTableField,
  complaintsTableHeadings,
  convertToTableData,
  defaultComplaintFilter,
  getCategoryChartData,
  getClosedDurationChartData,
  getLongestDurationBarChartData,
  getMonthlyComparisonBarChartData,
  getRaisedChartData,
  getStatusChartData,
  getZoneChartData,
  GraphControllerButton
} from "../../Utils/Constants/Complaints";
import {
  capitalizeFirstLetter,
  FilterSeparator,
  // InfoCardData,
  isFilterApplied,
  summaryRefreshTime
} from "../../Utils/Constants/Constants";
import Modal from "../../Components/Modal/Modal";
import SummaryHeader from "../../Components/SummaryHeader/SummaryHeader";

function Complaints(props) {
  const [selectedFilters, setSelectedFilters] = useState(
    defaultComplaintFilter
  );
  const [collapse, setCollapse] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    props.table.complaints.pageNumber
  );
  const [searchKey, setSearchKey] = useState("");
  const tableContainerRef = useRef(null);
  const filterContainerRef = useRef(null);
  const { height } = useResizeObserver(filterContainerRef);
  const [isResetSingleKey, setIsResetSingleKey] = useState(false);
  const horizontalScrollRef = useHorizontalScroll();
  const [show, setShow] = useState("initial");
  const [excelFile, setExcelFile] = useState(null);
  // eslint-disable-next-line
  const [time, setTime] = useState(new Date()); // for render

  const [summaryLastRefreshedAt, setSummaryLastRefreshedAt] = useState(null);
  const [filterQuery, setFilterQuery] = useState(null);
  const summaryRefreshTimer = useRef(null);

  const rerenderRef = useRef(false);

  useEffect(() => {
    rerenderRef.current = setInterval(() => {
      setTime(new Date());
    }, 30000);

    return () => {
      if (rerenderRef.current) {
        clearInterval(rerenderRef.current);
        rerenderRef.current = false;
      }
    };
  }, []);

  useEffect(() => {
    if (props.table.complaints.pageNumber) {
      setCurrentPage(props.table.complaints.pageNumber);
    }
  }, [props.table.complaints.pageNumber]);

  useEffect(() => {
    if (!isResetSingleKey) {
      setSelectedFilters(props.table.complaints.filter);
    }
  }, [props.table.complaints.filter, isResetSingleKey]);

  useEffect(() => {
    if (props.table.complaints.searchKey) {
      setSearchKey(props.table.complaints.searchKey);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const query = complaintsQueryBuilder(
      props.table.complaints.filter,
      props.locations.data
    );
    setFilterQuery(query);
  }, [props.locations.data, props.table.complaints.filter]);

  useEffect(() => {
    if (collapse || filterQuery === null) {
      return;
    }
    props.getAllComplaintsCount({
      filter: filterQuery
    });
    setSummaryLastRefreshedAt(+new Date());
    // eslint-disable-next-line
  }, [filterQuery, collapse]);

  useEffect(() => {
    if (summaryLastRefreshedAt) {
      if (summaryRefreshTimer.current) {
        clearInterval(summaryRefreshTimer.current);
        summaryRefreshTimer.current = null;
      }
      if (collapse) {
        return;
      }
    } else {
      return;
    }

    summaryRefreshTimer.current = setInterval(() => {
      props.getAllComplaintsCount({
        filter: filterQuery
      });
      setSummaryLastRefreshedAt(+new Date());
    }, summaryRefreshTime);
    // eslint-disable-next-line
  }, [summaryLastRefreshedAt, collapse]);

  const handleApplyClick = () => {
    props.setTableFilter("COMPLAINTS", selectedFilters);
  };

  const handleResetClick = (key) => {
    setIsResetSingleKey(true);
    setSelectedFilters({
      ...selectedFilters,
      [key]: defaultComplaintFilter[key]
    });
    props.setTableFilter("COMPLAINTS", {
      ...props.table.complaints.filter,
      [key]: defaultComplaintFilter[key]
    });
  };

  const handleClearClick = () => {
    props.setTableFilter("COMPLAINTS", defaultComplaintFilter);
    setSelectedFilters(defaultComplaintFilter);
    props.setTableSearchKey("COMPLAINTS", "");
    setSearchKey("");
  };

  const handleDisableFilter = () => {
    return window.location.pathname.split("/")[3] ? true : false;
  };

  return (
    <>
      <Routes>
        <Route
          path="/:complaintId"
          element={
            <ComplaintsPreview
              navigate={props.navigate}
              profile={props.profile}
              claims={props.claims}
              data={props.table.complaints.selectedComplaint}
              complaintsLoading={props.complaintsLoading}
              loading={props.complaints.loading}
              setErrorStatus={setErrorStatus}
              takeOverOnClick={() => {
                if (!props.claims?.complaints?.update?.reassign) {
                  setErrorStatus({
                    code: "custom",
                    message: "No permission to takeover the complaint"
                  });
                  return;
                }

                const selectedComplaint =
                  props.table.complaints.selectedComplaint;

                props.complaintTakeover(selectedComplaint?.documentId);
              }}
              closeComplaintClick={(files) => {
                if (!props.claims?.complaints?.update?.reassign) {
                  setErrorStatus({
                    code: "custom",
                    message: "No permission to close the complaint"
                  });
                  return;
                }
                const selectedComplaint =
                  props.table.complaints.selectedComplaint;

                props.fixComplaints(
                  selectedComplaint?.documentId,
                  selectedComplaint?.location?.id,
                  {
                    remarks: files.remarks,
                    image: files.image,
                    audio: files.audio
                  },
                  props.claims?.complaints?.update?.verify || false
                );
              }}
              verifyCompliantClick={(type) => {
                if (!props.claims?.complaints?.update?.verify) {
                  setErrorStatus({
                    code: "custom",
                    message: "No permission to verify the complaint"
                  });
                  return;
                }

                const selectedComplaint =
                  props.table.complaints.selectedComplaint;
                props.verifyCompliant(selectedComplaint?.documentId, type);
              }}
              setSelectedComplaint={props.setSelectedComplaint}
            />
          }
        />
      </Routes>
      <div
        className="inherit-parent-height inherit-parent-width position-relative overflow-hidden"
        ref={tableContainerRef}
      >
        <div
          className={`inherit-parent-width ${
            collapse ? "" : "margin-bottom-larger"
          }`}
        >
          <div className="display-flex flex-justify-content-space-between flex-align-items-center">
            <BreadCrumbs />
            <div className="display-flex">
              {/* <AddIcon
                color={
                  props.auth.theme.secondaryColor === "#0E0E0E"
                    ? "#FFFFFF"
                    : "#0E0E0E"
                }
              /> */}
              <div className=" display-flex flex-align-items-center">
                <Button
                  variant="transparent"
                  text="Download summary"
                  boxShadow={false}
                  icon={
                    props.complaintsLoading.export ? (
                      <div
                        className="qr-loader"
                        style={{ height: "16px", width: "16px" }}
                      />
                    ) : (
                      <DownloadIcon color="var(--tertiaryColor6)" />
                    )
                  }
                  onClick={() => {
                    if (!props.complaintsLoading.export) {
                      props.getComplaintsSummary();
                    }
                  }}
                  className="width-fit-content padding-left-large padding-right-large"
                />
                {/* {props.claims?.complaints?.update.penalty ? (
                  <>
                    <FilterSeparator />
                    <form
                      className=" padding-left-default padding-right-default"
                      onChange={(event) => {
                        if (event.target.files) {
                          if (
                            event.target.files[0]?.type !==
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          ) {
                            props.setErrorStatus({
                              code: "custom",
                              message: "Kindly upload a valid File"
                            });
                            return;
                          }

                          setExcelFile(event.target.files[0]);
                        }
                      }}
                    >
                      <label className=" display-flex flex-align-items-center">
                        {props.complaintsLoading.import ? (
                          <></>
                        ) : (
                          <input
                            type="file"
                            accept=".xls,.xlsx"
                            name="fileUploaderInput"
                            onClick={(event) => {
                              event.target.value = "";
                            }}
                            className="visibility-hidden position-absolute"
                          />
                        )}
                        <div
                          style={{
                            height: "32px",
                            //  width: "50px",
                            //  border: "dashed 2px #6E6E6E",
                            borderRadius: "4px"
                          }}
                          className="cursor-pointer display-flex flex-justify-content-center flex-align-items-center"
                        >
                          {props.complaintsLoading.import ? (
                            <div
                              className="qr-loader margin-right-default"
                              style={{ height: "16px", width: "16px" }}
                            />
                          ) : (
                            <ImportIcon color="var(--tertiaryColor)" />
                          )}

                          <div
                            style={{ color: "var(--tertiaryColor)" }}
                            className=" font-size-small padding-left-small"
                            data-cy="import-excel-button"
                          >
                            Import
                          </div>
                        </div>
                      </label>
                    </form>
                  </>
                ) : (
                  <></>
                )} */}
              </div>
            </div>
          </div>

          <div
            ref={filterContainerRef}
            className="padding-top-larger display-flex flex-justify-content-space-between"
          >
            <div
              style={{ width: "90%", flexWrap: "wrap", gap: "8px" }}
              className="display-flex flex-align-items-center"
            >
              <div style={{ width: "200px" }}>
                <SearchBox
                  title="SEARCH COMPLAINTS"
                  placeHolder="SEARCH COMPLAINTS"
                  value={searchKey}
                  onChange={(event) => {
                    if (event.target.value.length > 0) {
                      setSearchKey(event.target.value);
                    } else {
                      setSearchKey("");
                      props.setTableSearchKey("COMPLAINTS", "");
                    }
                  }}
                  showEnterIcon={
                    searchKey.length === 8 &&
                    props.table.complaints.searchKey !== searchKey
                      ? true
                      : false
                  }
                  enterOnClick={() => {
                    if (searchKey.length > 0) {
                      props.setTableSearchKey("COMPLAINTS", searchKey);
                    }
                  }}
                  showCloseIcon={
                    searchKey.length > 0 &&
                    props.table.complaints.searchKey === searchKey
                      ? true
                      : false
                  }
                  closeOnClick={() => {
                    setSearchKey("");
                    props.setTableSearchKey("COMPLAINTS", "");
                  }}
                />
              </div>
              <div
                style={{
                  width: `calc(100% - ${220 +
                    (isFilterApplied(selectedFilters, "COMPLAINTS")
                      .validation && 40)}px)`
                }}
                className="position-relative"
              >
                <FilterCarousal>
                  <div className="display-flex flex-align-items-center">
                    <DateRange
                      disabled={handleDisableFilter()}
                      loading={props.complaints.loading}
                      data-cy="DATE RANGE"
                      data={complaintFilterData(props.locations.data)[0]}
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.complaints.filter}
                      selected={selectedFilters["dateRange"]}
                    />

                    <FilterSeparator />

                    {/* <SingleSelect
                      disabled={handleDisableFilter()}
                      data-cy="CATEGORY-SINGLE"
                      data={complaintFilterData(props.locations.data)[0]}
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      defaultFilters={defaultComplaintFilter}
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.complaints.filter}
                      selected={selectedFilters["category"]}
                    />

                    <FilterSeparator />

                    <SingleSelect
                      disabled={handleDisableFilter()}
                      loading={props.complaints.loading}
                      data-cy="ISSUE-RAISED-BY-SINGLE"
                      data={complaintFilterData(props.locations.data)[2]}
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.complaints.filter}
                      selected={selectedFilters["issueRaised"]}
                    />

                    <FilterSeparator />

                    <SingleSelect
                      disabled={handleDisableFilter()}
                      loading={props.complaints.loading}
                      data-cy="ISSUE-TAKEN-BY-SINGLE"
                      data={complaintFilterData(props.locations.data)[3]}
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.complaints.filter}
                      selected={selectedFilters["issueTakenBy"]}
                    />

                    <FilterSeparator /> */}
                    <MultipleSelect
                      loading={props.complaints.loading}
                      data-cy="PCT-NO-MULTI"
                      data={complaintFilterData(props.locations.data)[1]}
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      disabled={handleDisableFilter()}
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.complaints.filter}
                      selected={selectedFilters["PCTNo"]}
                    />

                    <FilterSeparator />

                    <MultipleSelect
                      loading={props.complaints.loading}
                      data-cy="STATUS-MULTI"
                      data={complaintFilterData(props.locations.data)[2]}
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.complaints.filter}
                      selected={selectedFilters["status"]}
                    />

                    <FilterSeparator />

                    <MultipleSelect
                      loading={props.complaints.loading}
                      data-cy="WARD-MULTI"
                      data={complaintFilterData(props.locations.data)[3]}
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.complaints.filter}
                      selected={selectedFilters["ward"]}
                    />

                    <FilterSeparator />

                    <MultipleSelect
                      loading={props.complaints.loading}
                      data-cy="ZONE-MULTI"
                      data={complaintFilterData(props.locations.data)[4]}
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.complaints.filter}
                      selected={selectedFilters["zone"]}
                    />

                    <FilterSeparator />

                    <MultipleSelect
                      loading={props.complaints.loading}
                      data-cy="SOURCE-MULTI"
                      data={complaintFilterData(props.locations.data)[5]}
                      onResetClick={(key) => {
                        handleResetClick(key);
                      }}
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      appliedFilters={props.table.complaints.filter}
                      selected={selectedFilters["source"]}
                    />
                  </div>
                </FilterCarousal>
              </div>
            </div>

            {isFilterApplied(selectedFilters, "COMPLAINTS").validation && (
              <div
                style={{ width: "10%" }}
                className={`display-flex flex-justify-content-space-between`}
              >
                <div
                  style={{
                    width: "60%"
                  }}
                >
                  <Button
                    data-cy={`FILTER-APPLY-BUTTON${
                      props.complaints.loading ? "-LOADING" : ""
                    }`}
                    text="Apply"
                    boxShadow={false}
                    variant="filter"
                    loading={props.complaints.loading}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      handleApplyClick();
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "40%"
                  }}
                >
                  <Button
                    data-cy="FILTER-RESET-BUTTON"
                    variant="transparent"
                    text="Clear"
                    boxShadow={false}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      props.setTableFilter(
                        "COMPLAINTS",
                        defaultComplaintFilter
                      );
                      setSelectedFilters(defaultComplaintFilter);
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            height: `calc(100% - ${height + 32}px`
          }}
          className={`${
            collapse ? "overflow-hidden" : "overflow-scroll"
          } inherit-parent-width`}
        >
          {!collapse && (
            <div
              className="display-flex inherit-parent-width flex-justify-content-space-between overflow-hidden"
              style={{
                height: "597px"
              }}
            >
              <div
                style={{
                  width: "calc(100% - 44px)",
                  overflowX: "scroll"
                }}
                className="inherit-parent-height hide-scrollbar"
              >
                <SummaryHeader
                  summaryLastRefreshedAt={summaryLastRefreshedAt}
                  refreshOnClick={() => {
                    props.getAllComplaintsCount({
                      filter: filterQuery
                    });
                    setSummaryLastRefreshedAt(+new Date());
                  }}
                  isLoading={props.complaints.summaryLoading}
                />
                {/* <div className="display-flex flex-justify-content-space-between margin-top-larger">
                  {InfoCardData.map((data, i) => (
                    <div key={i} style={{ width: "calc(100% / 3 - 20px)" }}>
                      <InfoCard data={data} />
                    </div>
                  ))}
                </div> */}
                {show === "initial" && (
                  <div className="display-flex flex-justify-content-space-between hide-scrollbar">
                    <GraphCard
                      title="COMPLAINTS SOURCE"
                      theme={
                        props.auth.theme.primaryColor === "#0E0E0E"
                          ? "dark"
                          : "light"
                      }
                      isLoading={
                        !props.complaints?.summaryData.find(
                          (data) => data.title === "COMPLAINTS SOURCE"
                        )?.count || props.complaints.summaryLoading
                      }
                      graph={
                        <DoughnutChart
                          data={getRaisedChartData(
                            props.complaints?.summaryData.find(
                              (data) => data.title === "COMPLAINTS SOURCE"
                            )?.count
                          )}
                        />
                      }
                      legend={
                        <div className="display-flex flex-justify-content-center padding-top-large flex-direction-column">
                          {getRaisedChartData(
                            props.complaints?.summaryData.find(
                              (data) => data.title === "COMPLAINTS SOURCE"
                            )?.count
                          )?.datasets[0].backgroundColor.map((data, i) => (
                            <div key={i}>
                              <LegendCard
                                data={getRaisedChartData(
                                  props.complaints?.summaryData.find(
                                    (data) => data.title === "COMPLAINTS SOURCE"
                                  )?.count
                                )}
                                color={data}
                                index={i}
                              />
                            </div>
                          ))}
                        </div>
                      }
                    />
                    <div style={{ padding: "12px" }} />
                    <GraphCard
                      title="COMPLAINTS STATUS DATA"
                      isLoading={
                        !props.complaints?.summaryData.find(
                          (data) => data.title === "COMPLAINTS STATUS DATA"
                        )?.count || props.complaints.summaryLoading
                      }
                      theme={
                        props.auth.theme.primaryColor === "#0E0E0E"
                          ? "dark"
                          : "light"
                      }
                      graph={
                        <DoughnutChart
                          data={getStatusChartData(
                            props.complaints?.summaryData.find(
                              (data) => data.title === "COMPLAINTS STATUS DATA"
                            )?.count
                          )}
                          onSegmentClick={(value) => {
                            if (value.label) {
                              props.setTableFilter("COMPLAINTS", {
                                ...props.table?.complaints.filter,
                                status: [capitalizeFirstLetter(value.label)]
                              });
                            }
                          }}
                        />
                      }
                      legend={
                        <div className="display-flex flex-justify-content-center padding-top-large flex-direction-column">
                          {getStatusChartData(
                            props.complaints?.summaryData.find(
                              (data) => data.title === "COMPLAINTS STATUS DATA"
                            )?.count
                          )?.datasets[0].backgroundColor.map((data, i) => (
                            <div key={i}>
                              <LegendCard
                                data={getStatusChartData(
                                  props.complaints?.summaryData.find(
                                    (data) =>
                                      data.title === "COMPLAINTS STATUS DATA"
                                  )?.count
                                )}
                                color={data}
                                index={i}
                              />
                            </div>
                          ))}
                        </div>
                      }
                    />
                    <div style={{ padding: "12px" }} />
                    <GraphCard
                      title="ZONE WISE COMPLAINTS"
                      isLoading={
                        !props.complaints?.summaryData.find(
                          (data) => data.title === "ZONE WISE COMPLAINTS"
                        )?.count || props.complaints.summaryLoading
                      }
                      theme={
                        props.auth.theme.primaryColor === "#0E0E0E"
                          ? "dark"
                          : "light"
                      }
                      graph={
                        <DoughnutChart
                          data={getZoneChartData(
                            props.complaints?.summaryData.find(
                              (data) => data.title === "ZONE WISE COMPLAINTS"
                            )?.count
                          )}
                          onSegmentClick={(value) => {
                            if (value.label) {
                              props.setTableFilter("COMPLAINTS", {
                                ...props.table?.complaints.filter,
                                zone: [parseInt(value.label)]
                              });
                            }
                          }}
                        />
                      }
                      legend={
                        <div className="display-flex flex-justify-content-center padding-top-large flex-direction-column">
                          {getZoneChartData(
                            props.complaints?.summaryData.find(
                              (data) => data.title === "ZONE WISE COMPLAINTS"
                            )?.count
                          )?.datasets[0]?.backgroundColor?.map((data, i) => (
                            <div key={i}>
                              <LegendCard
                                units="Zone"
                                data={getZoneChartData(
                                  props.complaints?.summaryData.find(
                                    (data) =>
                                      data.title === "ZONE WISE COMPLAINTS"
                                  )?.count
                                )}
                                color={data}
                                index={i}
                              />
                            </div>
                          ))}
                        </div>
                      }
                    />
                  </div>
                )}

                <div
                  className={`display-flex flex-justify-content-space-between hide-scrollbar ${
                    show === "secondary" ? "" : "padding-top-larger"
                  }`}
                >
                  <GraphCard
                    title="CATEGORY WISE COMPLAINTS"
                    isLoading={
                      !props.complaints?.summaryData.find(
                        (data) => data.title === "CATEGORY WISE COMPLAINTS"
                      )?.count || props.complaints.summaryLoading
                    }
                    theme={
                      props.auth.theme.primaryColor === "#0E0E0E"
                        ? "dark"
                        : "light"
                    }
                    graph={
                      <DoughnutChart
                        data={getCategoryChartData(
                          props.complaints?.summaryData.find(
                            (data) => data.title === "CATEGORY WISE COMPLAINTS"
                          )?.count
                        )}
                        // onSegmentClick={(value) => {
                        //   if (value.label) {
                        //     props.setTableFilter("COMPLAINTS", {
                        //       ...props.table?.complaints.filter,
                        //       category: value.label
                        //     });
                        //   }
                        // }}
                      />
                    }
                    legend={
                      <div
                        ref={horizontalScrollRef}
                        className="display-flex flex-justify-content-center overflow-scroll flex-direction-column"
                      >
                        {getCategoryChartData(
                          props.complaints?.summaryData.find(
                            (data) => data.title === "CATEGORY WISE COMPLAINTS"
                          )?.count
                        )?.datasets[0]?.backgroundColor?.map((data, i) => (
                          <div className="overflow-scroll" key={i}>
                            <LegendCard
                              data={getCategoryChartData(
                                props.complaints?.summaryData.find(
                                  (data) =>
                                    data.title === "CATEGORY WISE COMPLAINTS"
                                )?.count
                              )}
                              color={data}
                              index={i}
                            />
                          </div>
                        ))}
                      </div>
                    }
                  />
                  <div style={{ padding: "12px" }} />

                  <GraphCard
                    title="COMPLAINTS MONTHLY COMPARISON"
                    isLoading={
                      !props.complaints?.summaryData.find(
                        (data) => data.title === "COMPLAINTS MONTHLY COMPARISON"
                      )?.count || props.complaints.summaryLoading
                    }
                    theme={
                      props.auth.theme.primaryColor === "#0E0E0E"
                        ? "dark"
                        : "light"
                    }
                    type="bar"
                    graph={
                      <BarChart
                        data={getMonthlyComparisonBarChartData(
                          props.complaints?.summaryData.find(
                            (data) =>
                              data.title === "COMPLAINTS MONTHLY COMPARISON"
                          )?.count
                        )}
                      />
                    }
                    legend={
                      <div
                        style={{
                          paddingTop: "31px"
                        }}
                      />
                    }
                  />
                  <div style={{ padding: "12px" }} />

                  <GraphCard
                    title="COMPLAINTS CLOSURE DURATION"
                    isLoading={
                      !props.complaints?.summaryData.find(
                        (data) => data.title === "COMPLAINTS CLOSURE DURATION"
                      )?.count || props.complaints.summaryLoading
                    }
                    theme={
                      props.auth.theme.primaryColor === "#0E0E0E"
                        ? "dark"
                        : "light"
                    }
                    graph={
                      <DoughnutChart
                        data={getClosedDurationChartData(
                          props.complaints?.summaryData.find(
                            (data) =>
                              data.title === "COMPLAINTS CLOSURE DURATION"
                          )?.count
                        )}
                      />
                    }
                    legend={
                      <div
                        ref={horizontalScrollRef}
                        className="display-flex flex-justify-content-center overflow-scroll flex-direction-column"
                      >
                        {getClosedDurationChartData(
                          props.complaints?.summaryData.find(
                            (data) =>
                              data.title === "COMPLAINTS CLOSURE DURATION"
                          )?.count
                        )?.datasets[0]?.backgroundColor.map((data, i) => (
                          <div key={i}>
                            <LegendCard
                              data={getClosedDurationChartData(
                                props.complaints?.summaryData.find(
                                  (data) =>
                                    data.title === "COMPLAINTS CLOSURE DURATION"
                                )?.count
                              )}
                              color={data}
                              index={i}
                            />
                          </div>
                        ))}
                      </div>
                    }
                  />
                </div>

                {show === "secondary" && (
                  <div className="display-flex flex-justify-content-space-between padding-top-larger hide-scrollbar">
                    <GraphCard
                      title="LONGEST DURATION COMPLAINTS"
                      type="line"
                      isLoading={
                        !props.complaints?.summaryData.find(
                          (data) => data.title === "LONGEST DURATION COMPLAINTS"
                        )?.complaints || props.complaints.summaryLoading
                      }
                      theme={
                        props.auth.theme.primaryColor === "#0E0E0E"
                          ? "dark"
                          : "light"
                      }
                      graph={
                        <LineChart
                          data={getLongestDurationBarChartData(
                            props.complaints?.summaryData.find(
                              (data) =>
                                data.title === "LONGEST DURATION COMPLAINTS"
                            )?.complaints
                          )}
                        />
                      }
                      legend={
                        <div
                          style={{
                            paddingTop: "31px"
                          }}
                        />
                      }
                    />
                    <div style={{ padding: "12px" }} />

                    <GraphCard
                      title="COMING SOON"
                      type="line"
                      comingSoon={true}
                      isLoading={
                        !props.complaints?.summaryData.find(
                          (data) => data.title === "LONGEST DURATION COMPLAINTS"
                        )?.complaints || props.complaints.summaryLoading
                      }
                      theme={
                        props.auth.theme.primaryColor === "#0E0E0E"
                          ? "dark"
                          : "light"
                      }
                      graph={
                        <LineChart
                          data={getClosedDurationChartData(
                            props.complaints?.summaryData.find(
                              (data) => data.title === "COMING SOON 1"
                            )?.count
                          )}
                        />
                      }
                      legend={
                        <div
                          style={{
                            paddingTop: "31px"
                          }}
                        />
                      }
                    />
                    <div style={{ padding: "12px" }} />

                    <GraphCard
                      title="COMING SOON"
                      type="line"
                      isLoading={
                        !props.complaints?.summaryData.find(
                          (data) => data.title === "LONGEST DURATION COMPLAINTS"
                        )?.complaints || props.complaints.summaryLoading
                      }
                      comingSoon={true}
                      theme={
                        props.auth.theme.primaryColor === "#0E0E0E"
                          ? "dark"
                          : "light"
                      }
                      graph={
                        <LineChart
                          data={getClosedDurationChartData(
                            props.complaints?.summaryData.find(
                              (data) => data.title === "COMING SOON 1"
                            )?.count
                          )}
                        />
                      }
                      legend={
                        <div
                          style={{
                            paddingTop: "31px"
                          }}
                        />
                      }
                    />
                  </div>
                )}
              </div>

              <GraphControllerButton
                selected={show}
                increment={() => {
                  setShow("secondary");
                }}
                decrement={() => {
                  setShow("initial");
                }}
              />
            </div>
          )}

          {height && (
            <div
              style={{
                height: `calc(100% - ${collapse ? 0 : 360}px`
              }}
              className="padding-top-larger"
            >
              <Table
                title="ALL COMPLAINTS"
                setCollapse={(data) => {
                  setCollapse(data);
                  if (tableContainerRef.current) {
                    tableContainerRef.current.scrollTop = 0;
                  }
                }}
                allowCollapse={true}
                collapse={collapse}
                headers={complaintsTableHeadings}
                sort={props.table.complaints.sort}
                pagination={true}
                onClick={(data) => {
                  props.navigate(`locations/complaints/${data.documentId}`);
                }}
                data={
                  isValidObject(props.complaints.data)
                    ? convertToTableData(
                        Object.values(props.complaints.data)
                      ).slice(0, collapse ? 50 : 6)
                    : []
                }
                handleSort={(title) => {
                  const isSameTitle =
                    props.table?.complaints?.sort?.title === title;
                  props.setTableSort("COMPLAINTS", {
                    title: title,
                    ascending: isSameTitle
                      ? !props.table?.complaints?.sort?.ascending
                      : true
                  });
                }}
                resetAllClick={() => {
                  handleClearClick();
                }}
                getField={complaintsTableField}
                totalPage={Math.ceil(props.complaints?.total / 50)}
                currentPage={currentPage}
                previousPageOnClick={() => {
                  props.getComplaintsPreviousPage();
                }}
                nextPageOnClick={() => {
                  props.getComplaintsNextPage();
                }}
                backgroundColor="background-color-primary"
              />
            </div>
          )}
        </div>
      </div>

      <Modal
        show={excelFile ? true : false}
        canIgnore={true}
        onClose={() => setExcelFile(null)}
        width=" width-400px"
        minWidth="width-400px"
        // maxHeight="max-height-90-percentage"
        background="background-color-tertiaryColor2"
        boxShadow="true"
        borderRadius="false"
        height="height-fit-content"
      >
        <div
          className="padding-larger display-flex flex-direction-column flex-align-items-center flex-justify-content-center text-align-center"
          style={{ color: "var(--tertiaryColor)" }}
          data-cy="excel-upload-modal"
        >
          <div className=" font-size-larger font-family-RHD-medium">
            Are you sure you want to upload this Excel file?
          </div>
          <div className=" font-size-medium padding-top-default">
            Make sure the data is correct and properly formatted before
            continuing.
          </div>
          <div className=" padding-top-larger display-flex inherit-parent-width ">
            <Button
              data-cy={`CANCEL-UPLOAD${
                props.complaintsLoading.import ? "-LOADING" : ""
              }-BUTTON`}
              text="Cancel"
              boxShadow={false}
              variant="transparent"
              loading={props.complaintsLoading.import}
              className=" padding-left-larger padding-right-larger"
              onClick={() => {
                setExcelFile(null);
              }}
            />

            <Button
              type="button"
              data-cy={`CONFIRM-UPLOAD${
                props.complaintsLoading.import ? "-LOADING" : ""
              }-BUTTON`}
              text="Confirm"
              boxShadow={false}
              // variant="transparent"
              loading={props.complaintsLoading.import}
              className=" padding-left-larger padding-right-larger "
              onClick={() => {
                props.importPenaltyFile(excelFile);
                setExcelFile(null);
              }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

const mapStateToProps = function(state) {
  return {
    locations: state.locations,
    complaints: state.complaints,
    table: state.table,
    auth: state.auth,
    profile: state.profile
  };
};

const mapDispatchToProps = function() {
  return {
    setSelectedTableData: (tableName, data) =>
      setSelectedTableData(tableName, data),
    setTableFilter: (tableName, data) => setTableFilter(tableName, data),
    complaintTakeover: (documentId) => complaintTakeover(documentId),
    fixComplaints: (complaintId, locationId, proof, verify) =>
      fixComplaints(complaintId, locationId, proof, verify),
    verifyCompliant: (documentId, type) => verifyCompliant(documentId, type),
    setTableSort: (tableName, data) => setTableSort(tableName, data),
    setTableSearchKey: (tableName, data) => setTableSearchKey(tableName, data),
    setErrorStatus: (data) => setErrorStatus(data),
    setSelectedComplaint: (complaintId, navigate) =>
      setSelectedComplaint(complaintId, navigate),
    getAllComplaintsCount: (data) => getAllComplaintsCount(data)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Complaints);
